import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface IOwnerType {
  foreName?: string;
  surName?: string;
  userName?: string;
  phoneNumber?: string;
  companyName?: string;
  type?: number;
  companyNid: string;
  regCode: string;
}

interface IOwnerState {
  ownerInfo?: IOwnerType;

  isConfirm?: boolean;
  stock?: number;
  phoneValid?: boolean;

  birthDate?: {
    year: string;
    month: string;
    day: string;
  };

  bankAccountInfo?: {
    shNr?: string;
    accountNr?: string;
    cardNr?: string;
    bankName?: string;
  };

  accomodationInfo?: {
    postalCode?: string;
    address?: string;
    cityInfo?: {
      cityCode?: number;
      cityName?: string;
    };
  };

  ownerAttachs?: {
    ownerAttach1: string;
    ownerAttach2: string;
    ownerAttach3: string;
    ownerAttach4: string;
  };
}

const initialState: IOwnerState = {};

export const ownerSlice = createSlice({
  name: "owner",
  initialState,
  reducers: {
    setOwnerInfo: (state, action: PayloadAction<IOwnerType>) => {
      state.ownerInfo = action.payload;
    },
    setBankAccountInfo: (
      state,
      action: PayloadAction<{
        accountNr?: string;
        cardNr?: string;
        shNr?: string;
        bankName?: string;
      }>
    ) => {
      state.bankAccountInfo = action.payload;
    },

    setPhoneValid: (state, action: PayloadAction<boolean>) => {
      state.phoneValid = action.payload;
    },

    setAccomodationInfo: (
      state,
      action: PayloadAction<{
        postalCode?: string;
        address?: string;
        cityInfo?: {
          cityCode?: number;
          cityName?: string;
        };
      }>
    ) => {
      state.accomodationInfo = action.payload;
    },
    setAttachFiles: (
      state,
      action: PayloadAction<{
        ownerAttach1: string;
        ownerAttach2: string;
        ownerAttach3: string;
        ownerAttach4: string;
      }>
    ) => {
      state.ownerAttachs = action.payload;
    },

    setOwnerConfirm: (state, action: PayloadAction<boolean>) => {
      state.isConfirm = action.payload;
    },
    setOwnerStock: (state, action: PayloadAction<number>) => {
      state.stock = action.payload;
    },

    setBirthDate: (
      state,
      action: PayloadAction<{
        year: string;
        month: string;
        day: string;
      }>
    ) => {
      state.birthDate = action.payload;
    },
  },
});

export const getOwnerState = (state: RootState) => state.owner;

export const {
  setOwnerInfo,
  setOwnerConfirm,
  setBankAccountInfo,
  setAccomodationInfo,
  setAttachFiles,
  setPhoneValid,
  setOwnerStock,
  setBirthDate,
} = ownerSlice.actions;

export default ownerSlice.reducer;
